<template>
  <div>
    <b-modal
      no-fade
      id="modal-novo-programa"
      no-close-on-esc
      no-close-on-backdrop
      title="Novo Programa"
      @show="onShow()"
    >
      <div>
        <b-form-row>
          <b-col lg="12">
            <b-form-group label="Código" label-size="sm" label-for="programa_id">
              <b-form-input maxlength="50" size="sm" id="programa_id" v-model="programa.programa_id"
               trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col lg="12">
            <b-form-group label="Título" label-size="sm" label-for="titulo">
              <b-form-input size="sm" id="titulo" maxlength="50" v-model="programa.titulo" trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col lg="12">
            <b-form-group label-size="sm" label="Cliente" label-for="cliente_id">
              <v-select
                id="cliente_id"
                :options="combos.clientes"
                label="cliente_id"
                :reduce="c => c.cliente_id"
                :clearable="false"
                v-model="programa.cliente_id"
              >
                <template
                  v-slot:option="option"
                >{{ `${option.cliente_id} - ${option.razao_social}`}}</template>
                <template
                  v-slot:selected-option="option"
                >{{ `${option.cliente_id} - ${option.razao_social}`}}</template>
                <template #no-options="{}">Sem dados a serem exibidos</template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-form-row>
      </div>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="saveRecord()" variant="primary">
          <i class="fas fa-check"></i> Gravar
        </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-novo-programa')">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
  name: "ModalNovoPrograma",
  data: function () {
    return {
      programa: {
        programa_id: "",
        cliente_id: 0,
        titulo: "",
      },
      combos: {
        clientes: [],
      },
    };
  },
  methods: {
    saveRecord() {
      if ((this.programa.titulo || "") === "") {
        this.$toasted.info("Digite o Título", {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning",
        });
        return false;
      }
      axios.post(`${baseApiUrl}/bid/programas`, this.programa).then(() => {
        this.$emit("updated");
        this.$bvModal.hide("modal-novo-programa");
      }).catch(showError);
    },
    onShow() {
      this.programa = {
        programa_id: "",
        cliente_id: 0,
        titulo: "",
      };
    },
    loadCombos() {
      // clientes
      axios
        .get(`${baseApiUrl}/clientes`)
        .then((resp) => {
          this.combos.clientes = resp.data;
        })
        .catch(showError);
    },
  },
  mounted() {
    this.loadCombos();
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 0 !important;
}

.vs__selected {
  margin: 2px 2px 2px !important;
}
</style>